// extracted by mini-css-extract-plugin
export default {"textBold":"styles_textBold__PrBoZ","centerLogo":"styles_centerLogo__DE9Ec","contactLogo":"styles_contactLogo__eMm6d","contact":"styles_contact__Qc7tR"};